import React, { Component } from 'react'
import { Cascader } from 'antd';
const options = [
    {
      value: 'zhejiang',
      label: 'Zhejiang',
      children: [
        {
          value: 'hangzhou',
          label: 'Hangzhou',
          children: [
            {
              value: 'xihu',
              label: 'West Lake',
            },
          ],
        },
      ],
    },
    {
      value: 'jiangsu',
      label: 'Jiangsu',
      children: [
        {
          value: 'nanjing',
          label: 'Nanjing',
          children: [
            {
              value: 'zhonghuamen',
              label: 'Zhong Hua Men',
            },
          ],
        },
      ],
    },
  ];
  const onChange = (value) => {
    console.log(value);
  };
export default class MyCascader extends Component {
  render() {
    return (
      <div>
        <Cascader options={options} onChange={onChange} placeholder="Please select" />
      </div>
    )
  }
}
